import Section from "../../components/Section/Section.js";
import {achievementSection} from "../../portfolio";

export default function Achievement() {
  return <Section sectionData={achievementSection} id="achievements" />;
}
